module.exports = __webpack_public_path__ + "img/3.45d83e71.png";